module.exports = __webpack_public_path__ + "img/c95f37d2b890ee517b3fc68d7d831c4.56a0f7c7.jpg";